import './Layout.scss';
import AccessModal from "../AccessModal/AccessModal";
import {useEffect, useState} from "react";
import {useCommonStore} from "../../hooks/useCommonStore";
import Header from "./Header/Header";
import {useResponsiveLayout} from "../../hooks/useResponsiveLayout";
import cn from 'classnames';
import Loading from "../Loading/Loading";
import {useLocation} from 'react-router-dom';

const Layout = ({ children, title }) => {
  const {userInfo, access, isLoading, stopLoading} = useCommonStore();
  const [accessModal, setAccessModal] = useState(false);
  const {isDesktop} = useResponsiveLayout();
  const location = useLocation();

  useEffect(() => {
    if (!access.authLevel) {
      setAccessModal(true);
    }

    const userLang = userInfo?.language;
    if (!!userLang && userLang !== localStorage.getItem('lang')) {
      localStorage.setItem('lang', userLang);
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (isLoading) {
      stopLoading();
    }
  }, [location]);

  return (
    <div className={cn('Layout-mob')}>
      <Header setAccessModal={setAccessModal}/>

      { isLoading && <Loading /> }
      {children}

      <AccessModal
        isModalOpen={accessModal}
        closeModal={() => setAccessModal(false)}
      />
    </div>
  );
}

export default Layout;
